import classNames from 'classnames';
import { colorBins, rampGradientCss } from './utils';
import type { ColorMapping, RampStop } from './types';
import styles from './ramp-bar.module.scss';

interface RampBarProps {
  stops: RampStop[];
  /** Binned ramps draw as flat bands, matching the painted map. */
  mapping?: ColorMapping;
  binCount?: number;
  className?: string;
}

/**
 * A horizontal colour-ramp bar drawn from ramp stops: smooth for a gradient,
 * banded for binned ranges. Decorative; label it where it is used.
 * @param {RampBarProps} props The stops and how to draw them.
 * @return {JSX.Element} The bar.
 */
export const RampBar = ({
  stops,
  mapping = 'gradient',
  binCount = 1,
  className,
}: RampBarProps) => {
  const background =
    mapping === 'binned'
      ? rampGradientCss(
          colorBins(0, 100, stops, binCount).flatMap((bin) => [
            { offset: bin.x0, color: bin.color },
            { offset: bin.x1, color: bin.color },
          ])
        )
      : rampGradientCss(stops);

  return (
    <div
      aria-hidden
      className={classNames(styles.rampBar, className)}
      // The gradient is built from data (the ramp's stops), so it can only be
      // set inline.
      style={{ background }}
    />
  );
};
